import useLocalStore from '../../../../hooks/useLocalStore';
import FJTextBaseEditingRightTop from '../view/FJTextBaseEditingRightTop';
import { memo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJActionTimeLine from '../../../../redux/action/FJActionTimeLine';
import FJActionRightTextBaseEditing from '../../../../redux/action/textBasedEditing/FJActionRightTextBaseEditing.js';

const FJTextBaseEditingRightTopContainer = memo(() => {
    useLocalStore();
    const dispatch = useDispatch();

    const minUnitConversion = useSelector(state => state.timeLine.minUnitConversion);
    const maxUnitConversion = useSelector(state => state.timeLine.maxUnitConversion);
    const unitConversion = useSelector(state => state.timeLine.unitConversion);
    const currentTime = useSelector(state => state.timeLine.currentTime);
    const totalTime = useSelector(state => state.timeLine.totalTime);
    const isPlaying = useSelector(state => state.rightTextBaseEditing.isPlaying);
    const hasUndo = useSelector(state => state.rightTextBaseEditing.hasUndo);
    const hasRedo = useSelector(state => state.rightTextBaseEditing.hasRedo);

    const changeUnitConversion = useCallback(
        unitConversion => {
            dispatch(FJActionTimeLine.setUnitConversionAction(unitConversion));
        },
        [dispatch],
    );

    const fitOnClickHandler = useCallback(() => {
        dispatch(FJActionTimeLine.fitUnitConversionAndPositionAction());
    }, [dispatch]);

    const togglePlayPauseHandler = useCallback(() => {
        if (isPlaying) {
            dispatch(FJActionRightTextBaseEditing.pauseAction());
        } else {
            dispatch(FJActionRightTextBaseEditing.playAction());
        }
    }, [dispatch, isPlaying]);

    const undo = useCallback(() => {
        if (!hasUndo) return;

        dispatch(FJActionRightTextBaseEditing.undoAction());
    }, [dispatch, hasUndo]);

    const redo = useCallback(() => {
        if (!hasRedo) return;

        dispatch(FJActionRightTextBaseEditing.redoAction());
    }, [dispatch, hasRedo]);

    return (
        <FJTextBaseEditingRightTop
            minUnitConversion={minUnitConversion}
            maxUnitConversion={maxUnitConversion}
            changeUnitConversion={changeUnitConversion}
            unitConversion={unitConversion}
            currentTime={currentTime}
            totalTime={totalTime}
            fitOnClickHandler={fitOnClickHandler}
            togglePlayPauseHandler={togglePlayPauseHandler}
            isPlaying={isPlaying}
            undo={undo}
            redo={redo}
            hasUndo={hasUndo}
            hasRedo={hasRedo}
        />
    );
});

FJTextBaseEditingRightTopContainer.displayName = 'FJTextBaseEditingRightTopContainer';

export default FJTextBaseEditingRightTopContainer;
